// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1W1Y5","header":"PatientBlock_header__3fUCk","label":"PatientBlock_label__2AE4C","option":"PatientBlock_option__3xpt6"};